"use client";

import styles from "./index.module.scss";
import { MyLink } from "@/components/MyLink";
import {
  articleCategories,
  newsCategories,
  serviceCategories,
  industories,
} from "@/constants/constants";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import { PostDirectory } from "@/types/types";
import { useRef } from "react";

type Props = {
  dir: PostDirectory;
};

export const SideList = (props: Props) => {
  const { dir } = props;
  const pathname = usePathname() || '';
  const ref = useRef<HTMLDivElement>(null);
  const category = pathname.split("/")[3];

  const categories = (() => {
    switch (dir) {
      case "article":
        return articleCategories;
      case "case":
        return undefined;
      case "news":
        return newsCategories;
      case "service":
        return serviceCategories;
    }
  })();

  const onClickOpenButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!ref.current) return;
    ref.current.classList.toggle(styles.isShow);
    event.currentTarget.classList.toggle(styles.isShow);
  };

  return (
    <div className={styles.container}>
      <button onClick={onClickOpenButton} className={styles.openButton}>
        カテゴリーから探す
      </button>
      <div className={styles.sideList} ref={ref}>
        <ul>
          {dir === "case" ? (
            <li>
              <p className={styles.sideListHead}>事例紹介</p>
              <ul className={styles.sideListGroup}>
                {industories.map((secondCategory) => {
                  const isActive = secondCategory.category === category;
                  return (
                    <li
                      className={styles.sideListItem}
                      key={secondCategory.category}
                    >
                      <MyLink
                        href={`/${dir}/category/${secondCategory.category}`}
                        className={
                          isActive
                            ? clsx(styles.sideListButton, styles.isActive)
                            : styles.sideListButton
                        }
                      >
                        {secondCategory.name}
                      </MyLink>
                    </li>
                  );
                })}
              </ul>
            </li>
          ) : (
            categories?.map((firstCategory) => {
              return (
                <li key={firstCategory.name}>
                  <MyLink
                    className={styles.sideListHead}
                    href={`/${dir}/category/${firstCategory.category}`}
                  >
                    {firstCategory.name}
                  </MyLink>
                  <ul className={styles.sideListGroup}>
                    {firstCategory.secondCategories.map((secondCategory) => {
                      const isActive = secondCategory.category === category;
                      return (
                        <li
                          className={styles.sideListItem}
                          key={secondCategory.category}
                        >
                          <MyLink
                            href={`/${dir}/category/${secondCategory.category}`}
                            className={
                              isActive
                                ? clsx(styles.sideListButton, styles.isActive)
                                : styles.sideListButton
                            }
                          >
                            {secondCategory.name}
                          </MyLink>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })
          )}
        </ul>
      </div>
    </div>
  );
};
